import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import { defineResources } from "jadro-pico-app/Resources/defineResources";

export const CommonResources = defineResources({
  [LanguageEnum.CS]: {
    actionBack: "Zpět",
    actionSave: "Uložit",
    actionCancel: "Zrušit",
    actionClose: "Zavřít",
    actionRetry: "Zkusit znovu",
    stateNotSet: "Nevyplněno",
    errorLoadHeadline: "Načtení selhalo",
    errorLoadSupporting: "Zkontrolujte připojení a zkuste to znovu",
    errorSave: "Uložení se nepodařilo",
  },
  [LanguageEnum.EN]: {
    actionBack: "Back",
    actionSave: "Save",
    actionCancel: "Cancel",
    actionClose: "Close",
    actionRetry: "Try again",
    stateNotSet: "Not set",
    errorLoadHeadline: "Failed to load",
    errorLoadSupporting: "Check your connection and try again",
    errorSave: "Failed to save",
  },
});
